import { Volume2, VolumeX, BookOpen, Settings, Info } from "lucide-react";
import { useGame } from "@/context/GameContext";
import { sound } from "@/lib/sound";

const Btn = ({ onClick, label, testid, children }) => (
  <button
    onClick={onClick}
    aria-label={label}
    title={label}
    data-testid={testid}
    className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 bg-black/40 text-white/80 backdrop-blur-md transition-colors hover:border-white/40 hover:text-white"
  >
    {children}
  </button>
);

export default function TopControls({ showAbout, onAbout, onAlbum, onSettings }) {
  const { state, setSetting } = useGame();
  const muted = state.settings.muted;

  return (
    <div className="fixed right-5 top-5 z-[90] flex items-center gap-2">
      {showAbout && (
        <button
          onClick={() => {
            sound.playClick();
            onAbout();
          }}
          data-testid="about-nav-button"
          className="flex items-center gap-2 rounded-full border border-white/15 bg-black/40 px-4 py-2 text-sm text-white/80 backdrop-blur-md transition-colors hover:border-white/40 hover:text-white"
        >
          <Info className="h-4 w-4" /> About <span className="kr text-white/50">/ 소개</span>
        </button>
      )}
      <Btn
        label={muted ? "Unmute" : "Mute"}
        testid="mute-toggle"
        onClick={() => {
          setSetting("muted", !muted);
          if (muted) sound.playClick();
        }}
      >
        {muted ? <VolumeX className="h-5 w-5" /> : <Volume2 className="h-5 w-5" />}
      </Btn>
      <Btn
        label="Memory Album"
        testid="album-button"
        onClick={() => {
          sound.playClick();
          onAlbum();
        }}
      >
        <BookOpen className="h-5 w-5" />
      </Btn>
      <Btn
        label="Settings"
        testid="settings-button"
        onClick={() => {
          sound.playClick();
          onSettings();
        }}
      >
        <Settings className="h-5 w-5" />
      </Btn>
    </div>
  );
}
